import react, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import { images } from "../../config/images";
import "./Dashboard.css";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { width } from "@mui/system";
import { getPlants, getProducts, getSizes } from "./services";
import { Grid } from "@mui/material";
import { userFootFallTracking } from "../FootFallReport/services";


const Dashboard = () => {
  const [selectedPlants, setSelectedPlants] = useState();
  const [selectedProducts, setSelectedProducts] = useState();
  const [selectedSize, setSelectedSize] = useState();
  const [selectedPlantId, setselectedPlantId] = useState();
  const [selectedProductId, setselectedProductId] = useState();
  const [selectedSizeId, setSelectedSizeId] = useState();
  const [selectYear, setSelectYear] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const notifyError = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const handleTostMsg = () => {
    notifyError("You don't have access");
  };

  // asynchronous function to fetch production data API
  const getData = async () => {
    try {
      const resp = await getPlants();
      setSelectedPlants(resp.data.payload);
      const resp1 = await getProducts();
      setSelectedProducts(resp1.data.payload);

      // Get size based on the product selected in filter
      if (selectedProducts) {
        const resp2 = await getSizes(resp1.data.payload[0].id);
        setSelectedSize(resp2.data.payload);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect hook to fetch data when component mounts
  useEffect(() => {
    getData();
    return () => { };
  }, []);

  useEffect(() => {
    let intervalId = null;
  
    const callUserFootFallTracking = () => {
      const moduleList = JSON.parse(localStorage.getItem("moduleList"));
      if (moduleList) {
        const module = moduleList.find((m) => m.name === "Dashboard");
        if (module) {
          const params = { module_id: module.id };
          try {
            userFootFallTracking(params);
          } catch (error) {
            console.error("Error calling userFootFallTracking:", error);
          }
        }
      }
    };
  
    const startTracking = () => {
      if (!intervalId) {
        console.log("▶️ Start API interval");
        callUserFootFallTracking(); // call immediately
        intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000);
      }
    };
  
    const stopTracking = () => {
      if (intervalId) {
        console.log("⏹ Stop API interval");
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  
    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopTracking(); // stop when tab hidden/minimized
      } else {
        startTracking(); // resume when tab active
      }
    };
  
    // Setup listener
    document.addEventListener("visibilitychange", handleVisibilityChange);
  
    // Start tracking immediately if tab is visible
    if (!document.hidden) {
      startTracking();
    }
  
    return () => {
      stopTracking();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  
  

  return (
    <>
      <div className="containerWrap">
        <Container maxWidth="xxl">
          <div style={{ marginBottom: "30px" }}>
            <Card className="production-card">
              <div className="d-flex  justify-content-between">
                <div
                  className="d-flex align-items-center title-block"
                  style={{ width: "max-content" }}
                >
                  <h2>Production</h2>
                  <div className="d-flex filter-box">
                    <Box style={{ width: "100px", marginBottom: "0" }}>
                      <select
                        className="form-input-class"
                        id="selectedClass"
                        // defaultValue="all"
                        value={selectedPlantId}
                        onChange={(event) =>
                          setselectedPlantId(event.target.value)
                        }
                        required
                      >
                        <option value="none" selected disabled hidden>
                          All
                        </option>
                        <option value="all"> All </option>
                        {selectedPlants ? (
                          selectedPlants.map((event) => (
                            <option value={event.id}>{event.name}</option>
                          ))
                        ) : (
                          <option>{"No Data Found"}</option>
                        )}
                        {/* <option value="alsantejl"> Santej </option>
                                                <option value="dhalka"> Dhalka </option>
                                                <option value="hosur"> Hosur </option>
                                                <option value="cuttack"> Cuttack </option> */}
                      </select>
                    </Box>
                    <Box style={{ marginBottom: "0" }}>
                      <select
                        className="form-input-class"
                        id="selectedClass"
                        // defaultValue="all"
                        value={selectedProductId}
                        onChange={(event) =>
                          setselectedProductId(event.target.value)
                        }
                        required
                      >
                        <option value="none" selected disabled hidden>
                          Plumbing Pipes & Fittings
                        </option>
                        <option value="all">All</option>
                        {selectedProducts ? (
                          selectedProducts.map((event) => (
                            <option value={event.id}>
                              {event.product_name}
                            </option>
                          ))
                        ) : (
                          <option>{"No Data Found"}</option>
                        )}
                        {/* <option value="plumbing">Plumbing Pipes & Fittings</option>
                                                <option value="sewerage">Sewerage Drainage Pipes & Fittings</option>
                                                <option value="agriculture">Agriculture Pipes & Fittings</option>
                                                <option value="watertanks">Water Tanks</option>
                                                <option value="industrial">Industrial Pipes & Fittings</option>
                                                <option value="cableprotection">Cable Protection</option>
                                                <option value="firesprinklers">Fire Sprinklers Pipes & Fittings</option> */}
                      </select>
                    </Box>
                    <Box style={{ width: "100px", marginBottom: "0" }}>
                      <select
                        className="form-input-class"
                        id="selectedClass"
                        // defaultValue="all"
                        value={selectedSizeId}
                        onChange={(event) =>
                          setSelectedSizeId(event.target.value)
                        }
                        required
                      >
                        <option value="none" selected disabled hidden>
                          All
                        </option>
                        <option value="all"> All </option>
                        {selectedSize ? (
                          selectedSize.map((event) => (
                            <option value={event.id}>{event.size}</option>
                          ))
                        ) : (
                          <option>{"No Data Found"}</option>
                        )}
                        {/* <option value="1/2"> 1/2' </option>
                                                <option value="3/4"> 3/4' </option>
                                                <option value="1"> 1 </option>
                                                <option value="1.25">1 ¹/₄'</option>
                                                <option value="1.5">1 ¹/₂'</option>
                                                <option value="2">2'</option>
                                                <option value="2.5">2 ¹/₂'</option>
                                                <option value="3">3'</option>
                                                <option value="4">4'</option>
                                                <option value="12">12'</option> */}
                      </select>
                    </Box>
                  </div>
                </div>
                <Box style={{ width: "120px", marginRight: "2rem" }}>
                  <select
                    className="form-input-class"
                    id="selectedClass"
                    value={selectYear || `FY - ${new Date().getFullYear()}`}
                    onChange={(event) => setSelectYear(event.target.value)}
                    required
                  >
                    <option
                      value={`FY - ${new Date().getFullYear()}`}
                      disabled
                      hidden
                    >
                      FY - {new Date().getFullYear()}
                    </option>
                    <option value="all">All</option>
                    {[...Array(10)].map((_, index) => {
                      const year = new Date().getFullYear() - index;
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>
                </Box>
              </div>
              <div className="d-flex product">
                <div className="production-item">
                  <div className="production-icon">
                    <img src={images.totalOrder} alt="" />
                  </div>
                  <div className="production-name">
                    <p>Total Order</p>
                    <h2>8645</h2>
                  </div>
                </div>
                <div className="production-item">
                  <div className="production-icon">
                    <img src={images.packed} alt="" />
                  </div>
                  <div className="production-name">
                    <p>Packed</p>
                    <h2>1200</h2>
                  </div>
                </div>
                <div className="production-item">
                  <div className="production-icon">
                    <img src={images.dispachted} alt="" />
                  </div>
                  <div className="production-name">
                    <p>Dispatched</p>
                    <h2>5200</h2>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Card className="dashbord-card" sx={{pointerEvents:"none"}}>
                  {/* <Link to="/production-planning" style={{ textDecoration: "none" }}> */}
                  <Link to="" style={{ textDecoration: "none" }}>

                    <div className="module-item">
                      <div className="module-icon">
                        <img src={images.production_plan} alt="" />
                      </div>
                      <div className="module-name">
                        <h2>
                          Production
                          <br />
                          Planning
                        </h2>
                      </div>
                    </div>
                  </Link>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Card className="dashbord-card">
                  <Link to="/packing" style={{ textDecoration: "none" }}>
                    <div className="module-item">
                      <div className="module-icon">
                        <img src={images.packing} alt="" />
                      </div>
                      <div className="module-name">
                        <h2>Packing</h2>
                      </div>
                    </div>
                  </Link>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Card className="dashbord-card" sx={{pointerEvents:"none"}}>
                  <Link to="" style={{ textDecoration: "none" }}>
                  {/* <Link to="/dispatch-summary" style={{ textDecoration: "none" }}> */}
                    <div className="module-item">
                      <div className="module-icon">
                        <img src={images.dispatch_summary} alt="" />
                      </div>
                      <div className="module-name">
                        <h2>
                          Dispatch
                          <br />
                          Summary
                        </h2>
                      </div>
                    </div>
                  </Link>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Card className="dashbord-card" sx={{pointerEvents:"none"}}>
                  {/* <Link to="/production-analytics" style={{ textDecoration: "none" }}> */}
                  <Link to="" style={{ textDecoration: "none" }}>
                    <div className="module-item">
                      <div className="module-icon">
                        <img src={images.production_anl} alt="" />
                      </div>
                      <div className="module-name">
                        <h2>
                          Production
                          <br />
                          Analytics
                        </h2>
                      </div>
                    </div>
                  </Link>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Card className="dashbord-card">
                  <Link to="/extruderStatus" style={{ textDecoration: "none" }}>
                    <div className="module-item">
                      <div className="module-icon">
                        <img src={images.extruder} alt="" />
                      </div>
                      <div className="module-name">
                        <h2>
                          Extruder
                          <br />
                          Status
                        </h2>
                      </div>
                    </div>
                  </Link>
                </Card>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Dashboard;
